export const composePossessiveNoun = (name: string) => {
  const possessiveString = name.endsWith('s') ? "'" : "'s";

  return `${name}${possessiveString}`;
};
